import BookItem from "../common/bookItem";
export default class VisibleSwitchAnsChild extends BookItem {
    constructor(el, target) {
        super(el, target);

        this.connectNumber = this.el.connectNumber;
        this.notFirstFrame = this.el.notFirstFrame;
        this.ctrlObjTouch = this.el.ctrlObjTouch;

        this.add_mouse_event();

        // 設定是否觸碰
        if (this.ctrlObjTouch == false) {
            this.target.mouseEnabled = false;
        }
        else {
            this.target.mouseEnabled = true;
        }

        // 設定美術設定的初始停留影格
        if (this.notFirstFrame == true) {
            this.target.gotoAndStop(1);
        } else {
            this.target.gotoAndStop(0);
        }
    }

    init() {
    }

    trigger() {
        const self = this;

        // this.mainGroup = this.itemControl.getItemsByClassPageId("visibleSwitchAnsStepAllGroup", this);

        self.isOpen = !self.isOpen;

        if (!self.isOpen) {
            // 現在是要全關
            this.HideAnswer();
        }
        else {
            // 現在是要全開
            this.ShowAnswer();
        }

        self.ChildNotice();
    }

    /**
     * 點擊事件
     */
    add_mouse_event() {
        console.log("add event")
        this.target.mouseChildren = false;
        this.target.removeAllEventListeners();
        this.target.addEventListener("click", () => {
            this.trigger();
        });
    }

    // TIP : 要做判斷控制全開或全關
    /**
     * 被控制開啟或關閉
     * @param {*} state 要求被控制時的狀態
     */
    ControlTrigger(state) {
        const self = this;

        self.isOpen = state;
        // console.log("self.isOpen", self.isOpen);
        // console.log("this.isOpen", this.isOpen);
        if (self.isOpen == false) {
            // 現在是要全關
            // console.log("要全關");
            this.HideAnswer();
        }
        else if (self.isOpen == true) {
            // 現在是要全開
            // console.log("要全開");
            this.ShowAnswer();
        }

        // console.log("ControlTrigger!!!", this.mainGroup);
        // self.ChildNotice();
    }

    ShowAnswer() {
        if (this.notFirstFrame == true) {
            this.target.gotoAndStop(0);
        } else {
            this.target.gotoAndStop(1);
        }
    }

    HideAnswer() {
        if (this.notFirstFrame == true) {
            this.target.gotoAndStop(1);
        } else {
            this.target.gotoAndStop(0);
        }
    }
}